"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPath = exports.getMaxHeight = exports.getFormula = void 0;
const getMaxHeight = (height, rate = 0.5) => height * (0.25 + 0.5 * rate);
exports.getMaxHeight = getMaxHeight;
const getFormula = ({
  height,
  width,
  heightRate
}) => {
  const maxHeight = getMaxHeight(height, heightRate);
  const diff = height - maxHeight;
  const t = 1.5;
  const b = (4 * maxHeight / t - maxHeight) / width;
  const a = (maxHeight - b * width) / width ** 2;
  return x => {
    const _x = width - x;
    return a * _x ** 2 + b * _x + diff;
  };
};
exports.getFormula = getFormula;
const getPath = ({
  height,
  width,
  formula
}) => {
  const steps = 20;
  const pointsArray = [];
  for (let i = steps; i >= 0; i--) {
    const x = width / steps * i;
    const y = formula(x);
    pointsArray.unshift([x, y]);
  }

  // The smoothing ratio
  const smoothing = 0.5;
  const getLine = (pointA, pointB) => {
    const lengthX = pointB[0] - pointA[0];
    const lengthY = pointB[1] - pointA[1];
    return {
      length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
      angle: Math.atan2(lengthY, lengthX)
    };
  };
  const round = num => Math.round(num * 100) / 100;
  const getControlPoint = (current, previous, next, reverse) => {
    const previousPoint = previous || current;
    const nextPoint = next || current;
    const line = getLine(previousPoint, nextPoint);
    const angle = line.angle + (reverse ? Math.PI : 0);
    const length = line.length * smoothing;
    const xPoint = current[0] + Math.cos(angle) * length;
    const yPoint = current[1] + Math.sin(angle) * length;
    return [xPoint, yPoint];
  };
  const bezierCommand = (point, i, a) => {
    const controlPointS = getControlPoint(a[i - 1], a[i - 2], point);
    const controlPointE = getControlPoint(point, a[i - 1], a[i + 1], true);
    return `C ${round(controlPointS[0])},${round(controlPointS[1])} ` + `${round(controlPointE[0])},${round(controlPointE[1])} ` + `${round(point[0])},${round(point[1])}`;
  };
  const getSVGAttributes = points => {
    const d = points.reduce((acc, point, i, a) => i === 0 ? `M ${round(point[0])},${round(point[1])}` : `${acc} ${bezierCommand(point, i, a)}`, '');
    return d + ` L ${width},${height} L 0,${height} z`;
  };
  return getSVGAttributes(pointsArray);
};
exports.getPath = getPath;